import { Box, Typography } from "@mui/material"
import { makeStyles } from "tss-react/mui"
import { fetchRoadmapByPeriod, FetchRoadmapResponse, NewsQuery } from "../newsApi"
import { useApiQuery } from "../../../core/api/useApiQuery"
import { LocalizedStrict } from "../../localization/components/AppLocalized"
import { LoadingSpinner } from "../../../shared/components/loading/LoadingSpinner"
import { RoadmapContent } from "./RoadmapContent"

const useStyles = makeStyles()((theme) => ({
    root: {
        padding: "0 1rem",
    },
    error: {
        color: theme.palette.error.main,
        textAlign: "center",
        padding: theme.spacing(4),
    },
}))

const selectNews = (data: FetchRoadmapResponse) => data.roadmaps

export function RoadmapCardTab() {
    const { classes } = useStyles()
    const { data, isLoading, error } = useApiQuery(fetchRoadmapByPeriod, {
        queryName: NewsQuery.LIST,
        dependencies: {},
        select: selectNews,
    })

    if (isLoading) {
        return (
            <Box className={classes.root}>
                <LoadingSpinner />
            </Box>
        )
    }

    if (error) {
        return (
            <Box className={classes.root}>
                <LocalizedStrict id="news-new-load-error">
                    <Typography className={classes.error}>Error loading roadmap features</Typography>
                </LocalizedStrict>
            </Box>
        )
    }

    return <RoadmapContent items={data ?? []} />
}
